const BoxOpenIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14_42)">
        <path d="M23.25 21H0.75V3H23.25V21Z" stroke="white" />
        <path
          d="M2.82057 4.47973C2.92604 4.26528 3.15807 4.14223 3.39361 4.17387L11.9999 5.24965L20.6061 4.17387C20.8417 4.14574 21.0737 4.26879 21.1792 4.47973L22.6452 7.41176C22.9616 8.04106 22.6241 8.80395 21.9491 8.99731L16.2046 10.6391C15.7159 10.7797 15.1921 10.5723 14.9319 10.1364L11.9999 5.24965L9.06783 10.1364C8.80768 10.5723 8.28385 10.7797 7.79518 10.6391L2.05416 8.99731C1.37565 8.80395 1.04166 8.04106 1.35807 7.41176L2.82057 4.47973ZM12.0385 7.49965L13.9686 10.7129C14.4924 11.5848 15.5366 11.9997 16.5174 11.7184L20.9999 10.4387V16.3098C20.9999 17.0832 20.4725 17.7582 19.7202 17.9481L12.5448 19.7411C12.1862 19.8325 11.81 19.8325 11.4549 19.7411L4.27955 17.9481C3.52721 17.7547 2.99986 17.0797 2.99986 16.3063V10.4352L7.4858 11.7184C8.46315 11.9997 9.5108 11.5848 10.0346 10.7129L11.9612 7.49965H12.0385Z"
          fill="#0051FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_14_42">
          <rect width="22.5" height="18" fill="white" transform="translate(0.75 3)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BoxOpenIcon;
